export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

    $(document).ready(function(){


          var $grid = $('#news-grid').imagesLoaded( function() {
          
              $grid.isotope({
                itemSelector: '.grid-item',
                percentPosition: true,
                masonry: {
                  columnWidth: '.grid-sizer',
                  gutter: '.gutter-sizer'
                }
              });


              $('#news-nav a').click(function(){
                $('#news-nav .current').removeClass('current');
                $(this).addClass('current');
       
                var selector = $(this).attr('data-filter');
                $('#news-grid').isotope({
                    filter: selector,
                    animationOptions: {
                        duration: 750,
                        easing: 'linear',
                        queue: false
                    }
                 });
               return false;
              }); 

          });



    });

    /* eslint-enable */

  },
};




// WEBPACK FOOTER //
// ./scripts/routes/archive.js